import { render, staticRenderFns } from "./SlotPicker.vue?vue&type=template&id=0892bfd4&scoped=true&"
import script from "./SlotPicker.vue?vue&type=script&lang=js&"
export * from "./SlotPicker.vue?vue&type=script&lang=js&"
import style0 from "./SlotPicker.vue?vue&type=style&index=0&id=0892bfd4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0892bfd4",
  null
  
)

export default component.exports